export default __webpack_public_path__ + "coreldraw.012e10aa.png";